import { ReactNode, useMemo, useState } from 'react';
import { Swiper } from 'swiper/react';

import PpCardListContext, { PpCardListContextProps } from '../context/PpCardListContext';

type Props = Pick<PpCardListContextProps, 'data' | 'type' | 'giftItemId'> & {
    children?: ReactNode;
};

function PpCardProvider({
    data, type, giftItemId, children,
}:Props) {
    const [indicator, setIndicator] = useState<number>(0);
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [swiper, setSwiper] = useState<typeof Swiper|undefined>(undefined);
    const value = useMemo(() => ({
        data,
        type,
        giftItemId,
        indicator,
        setIndicator,
        sliderIndex,
        setSliderIndex,
        swiper,
        setSwiper,
    }), [indicator, sliderIndex, swiper, data, type, giftItemId]);
    return (
        <PpCardListContext value={value}>
            {children}
        </PpCardListContext>
    );
}

export default PpCardProvider;
